/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RolesApi } from '../api/roles.api';
import { switchMap, map } from 'rxjs/operators';
import { RolesData } from '../../../interfaces/common/roles';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class RolesService extends RolesData {

  constructor(private api: RolesApi , private http: HttpClient) {
    super();
  }

  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<any>{
      return this.api.getById(url);
  }

  searchList(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }

  create(url: string, data:any): Observable<any> {
    return this.api.add(url,data);
  }

  createTable(url: string, body: any, options?: any) { // Add an optional `options` parameter
    return this.http.post(url, body, options);
  }

  
  update(url: string, data:any): Observable<any> {
    return this.api.update(url,data);
  }

  updateWithHeaders(url: string, data: any): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  });
  return this.http.put(url, data, { headers });
}
  listWithHeaders(url: string): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  });
  return this.http.get(url, { headers });
}
  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
